import { render, staticRenderFns } from "./district__list.vue?vue&type=template&id=fb73dd92"
import script from "./district__list.vue?vue&type=script&lang=js"
export * from "./district__list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports